<template>
  <div class="bg-dim flex-col" @click="closeReceipt">
    <div class="safe-area absolute">
      <div class="popup-wrap">
        <iframe class="iframe" :src="receiptUrl"></iframe>
      </div>
      <div class="button-wrap">
        <button class="button-bg-yellow" @click="closeReceipt">닫기</button>
      </div>
    </div>
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';

export default {
  name: "receiptPopup",
  components: {BottomButton},
  props: {
    receiptUrl: String
  },
  methods: {
    closeReceipt() {
      this.$emit('toggleReceiptPopup');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/myemarticon/receiptPopup.scss';
</style>